import { CATEGORY_GROUP } from "components/EditorHome/Constants";
import { INITIAL_TEXT_OBJECT } from "constants/TextEditor";

export const initialState = {
  text: {
    id: "",
    TextName: "",
    Text: "",
    Group: CATEGORY_GROUP.case,
  },
  drawer:{
    visibility: false,
    content: INITIAL_TEXT_OBJECT
  },
  standardAdapters: {
    data: [],
    isLoading: false,
  },
};
